import { Flex } from '@dapperlabs/core-fe';
import React from 'react';
import { packOddsReduceSum } from 'src/lib/contentful/utils';

import { PackDropItem } from '.';
import { DistributionExtended } from '../types';
interface Props {
  distributions: DistributionExtended[];
  isActiveDrop?: boolean;
  isStarter?: boolean;
}

export const PacksInDropList = ({
  distributions = [],
  isActiveDrop,
  isStarter,
}: Props) => (
  <Flex
    justifyContent={['space-between']}
    direction={['column', 'column', 'row']}
    gap={[8]}
  >
    {distributions?.map((drop) => (
      <PackDropItem
        key={drop?.id}
        availableSupply={drop?.availableSupply}
        cardBg={drop?.images?.[1]?.url}
        cardImg={drop?.images?.[0]?.url}
        distributionId={drop?.id}
        endTime={drop.endTime}
        guaranteeLabel={drop?.guaranteeLabel}
        isActiveDrop={isActiveDrop}
        isStarterPack={isStarter}
        packPrice={drop?.price?.value}
        packTitle={drop?.title}
        startTime={drop.startTime}
        tier={drop?.tier}
        totalPacks={
          drop?.totalPacks
            ? drop?.totalPacks
            : drop?.packOdds.reduce(packOddsReduceSum, 0)
        }
      />
    ))}
  </Flex>
);
